import axios from 'axios'
import store from '@/store'
import VueRouter from 'vue-router';

const routes = [{
                    path: '/login',
                    name: 'login_erro',
                    exact: true,
                    component: () => import('../pages/Login.vue'),
                    meta: {
                        publica: true
                    }
                }]

const router = new VueRouter({
    routes
  })

const http = axios.create({
    //baseURL: 'http://localhost:3000/',
    baseURL: `${process.env.VUE_APP_SERVICE_URL}/`,
    headers: {
        'Accept': 'application/json',
        'Content': 'application/json',
    }
})

http.interceptors.request.use(function (config) {
    const token = store.state.token

    if (token) {
        config.headers.Authorization = token
    }

    return config
}, function (erro) {
    return Promise.reject(erro)
})

http.interceptors.response.use((response) => {
    if(response.status === 401) {
        console.log("Usuário sem autorização");
    }
    return response;
}, (error) => {
    if (error.response && error.response.data && error.response.data.status =='403') {
        console.log("You are not authorized"+error.response.data.status);

        console.log("Limpando storage");
        // store.mutations.clearLocalStorage();

        router.push({ name: "login_erro" });
        // window.location.reload();

        // localStorage.clear();


        this.$store.state.token = null
        this.$store.state.usuario = null
        this.$store.state.perfil = null
        this.$store.state.nome = null

        return Promise.reject(error.response.data);

    }
    return Promise.reject(error);
});

export default http
